module.exports = "<div id=\"initial-load\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 806
// module chunks = 9